import { createFileRoute } from '@tanstack/react-router';
import { ReactFlowProvider } from '@xyflow/react';

import { NexusBuilder } from '@/features/nexus/NexusBuilder';
import { NexusStoreProvider } from '@/features/nexus/providers/NexusStoreProvider';
import { PageLayout } from '@/features/page-layout/PageLayout';

export const Route = createFileRoute('/_protected/t/$tenantId/nexus/$projectId/')({
  component: NexusBuilderRoute,
});

function NexusBuilderRoute() {
  const { projectId } = Route.useParams();

  return (
    <ReactFlowProvider>
      <NexusStoreProvider>
        <PageLayout header>
          <NexusBuilder source={{ kind: 'MAPPING', projectId }} />
        </PageLayout>
      </NexusStoreProvider>
    </ReactFlowProvider>
  );
}
